import { put } from "redux-saga/effects";
import pathToRegexp from "path-to-regexp";
import { ROUTER_CACHE_RESTORED } from "../CONSTANTS";
import * as CLIENTS from "model/subsystems/clients/CONSTANTS";

export default function* onRoutePop(action) {
  const actualpath = action.payload.location.pathname;
  if (actualpath.startsWith("/client/")) {
    const pathRegexp = pathToRegexp("/client/:clientId/:subroutes+");
    const pathMatch = actualpath.match(pathRegexp);
    if (pathMatch && pathMatch[1].match(/[pc]-.+/)) {
      const client = pathMatch[1].split("-");
      const clientType = client[0];
      const clientId = client[1];
      if (["p", "c"].includes(clientType)) {
        yield put({
          type: CLIENTS.ADD_CLIENT,
          payload: {
            remoteId: clientId,
            type: clientType === "p" ? "PERSON" : "COMPANY",
            select: true,
            data: {},
          },
        });
      }
    }
  }
  yield put({ type: ROUTER_CACHE_RESTORED });
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/onRoutePop.js